// extracted by mini-css-extract-plugin
export default {"interviewContainer":"interviewLayout_interviewContainer__scHcf","interviewWrapper":"interviewLayout_interviewWrapper__viWGi"};